import { Link } from 'react-router-dom';
import { Scale, X } from 'lucide-react';
import { useCompare } from '../contexts/CompareContext';

/**
 * Floating bottom-left widget that appears when the user has added at
 * least one scent to compare. Clicking it routes to /compare; the X
 * button clears the selection in one shot.
 *
 * Intentionally placed bottom-LEFT (the floating Messenger help bubble
 * already occupies the bottom-right). Pinned above the safe-area inset
 * so it's visible on iOS PWA installs.
 */
export default function CompareWidget() {
  const { ids, clear, max } = useCompare();
  if (ids.length === 0) return null;

  return (
    <div
      className="fixed left-3 sm:left-5 z-40 flex items-stretch shadow-2xl"
      style={{ bottom: 'calc(0.75rem + env(safe-area-inset-bottom))' }}
      data-testid="compare-widget"
    >
      <Link
        to="/compare"
        className="flex items-center gap-2 bg-[#D4AF37] text-black px-4 py-3 hover:bg-[#F3E5AB] transition-colors"
        data-testid="compare-widget-link"
      >
        <Scale className="w-4 h-4" strokeWidth={2.2} />
        <span className="text-xs uppercase tracking-[0.18em] font-sans font-semibold">
          Compare {ids.length}/{max}
        </span>
      </Link>
      <button
        type="button"
        onClick={clear}
        title="Clear compare list"
        data-testid="compare-widget-clear"
        className="px-3 bg-black text-white/60 hover:text-red-400 transition-colors border-l border-white/10"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
